import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import emailjs from "emailjs-com";
import HeaderFour from '../header/HeaderFour';
import Contact from '../inner/breadcrumb/Contact';
import Footer from '../elements/Footer';
import ContactForm from './ContactForm';
import WOW from "wowjs";
import HeaderNew from '../header/HeaderNew';



function ContactPage() {

    const [footers, setFooters] = useState([]); // Set the initial value to an empty array

    useEffect(() => {
        function header() {
            axios
                .get("https://solanthegroup.com/admin/api/footers")
                .then((response) => {
                    setFooters(response.data[0]);
                })
                .catch((error) => {

                });
        }
        header();
    }, []);

    return (
        <div className='service-details contact-page'>
            <div className="">
                <HeaderNew />
                <main>
                    {/* <div className="breadcrumb-area bg_image tmp-section-gap"
                        style={{ backgroundImage: `url(assets/images/breadcrumb/contact.webp)` }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb-inner text-center">
                                        <h1 className="title split-collab">Contact Us</h1>
                                        <ul className="page-list">
                                            <li className="tmp-breadcrumb-item">
                                                <a href="/">Home</a>
                                            </li>
                                            <li className="icon">
                                                <i className="fa-solid fa-angle-right" />
                                            </li>
                                            <li className="tmp-breadcrumb-item active">
                                                Contact Us</li>
                                        </ul>
                                        <div className="circle-1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* tmp contact area */}
                    <div className="contact-area tmp-section-gap">
                        <div className="container">
                            <div className="row g-5">
                                <div className="col-lg-5">
                                    <div className="contact-inner">
                                        <div className="section-head section-head-one-side text-align-left">
                                            <span className="title">Contact Us</span>
                                        </div>
                                        <ul className="ft-link ft-link-style-three">
                                            <li>
                                                <div className="single-contact background-transparent bg-custom"
                                                    style={{ backgroundColor: "white!important" }}>
                                                    <div className="icon">
                                                        <i className="fa-light fa-phone" />
                                                    </div>
                                                    <div className="content">
                                                        <span>Call Us</span>
                                                        <a className="contact-here" href={`tel:${footers.phone}`}>
                                                            {footers.phone}
                                                        </a>
                                                        <br />
                                                        <a className="contact-here" href={`tel:${footers.phone2}`}>
                                                            {footers.phone2}
                                                        </a>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="single-contact background-transparent bg-custom">
                                                    <div className="icon">
                                                        <i className="fa-solid fa-envelope-open-text" />
                                                    </div>
                                                    <div className="content">
                                                        <span>E-mail</span>
                                                        <a
                                                            className="contact-here"
                                                            href={`mailto:${footers.email}`}
                                                        >
                                                            {footers.email}
                                                        </a>
                                                    </div>
                                                </div>
                                            </li>
                                            {footers.address &&
                                                <li>
                                                    <div className="single-contact background-transparent bg-custom">
                                                        <div className="icon">
                                                            <i className="fa-regular fa-map-location-dot" />
                                                        </div>
                                                        <div className="content">
                                                            <span>Address</span>
                                                            <a className="contact-here" href="#">
                                                                {footers.address}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </li>
                                            }
                                        </ul>
                                        {/* <div className="tmp-tag-list tag-list-one">
                                <a className="tag-list" href="#">
                                    Facebook
                                </a>
                                <a className="tag-list" href="#">
                                    Twitter
                                </a>
                                <a className="tag-list" href="#">
                                    Linkedin
                                </a>
                                <a className="tag-list" href="#">
                                    Skype
                                </a>
                                <a className="tag-list" href="#">
                                    Pinterest
                                </a>
                                </div> */}
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="contact-inner">
                                        <div className="section-head section-head-one-side text-align-left">
                                            <span className="title">GET IN TOUCH</span>
                                            {/* <p className="description">
                                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                                                eiusmod tempor incididunt ut labore et dolor magnaaliqua.
                                            </p> */}
                                        </div>
                                        <div className="contact-form style-two">
                                            <div id="form-messages" />
                                            <ContactForm />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* tmp contact area */}
                    {/* <div className="tmp-map-area tmp-sectiongapBottom">
                        <div className="map-area-flotimg-container">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56516.2859130569!2d85.24819285450387!3d27.709014520769113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb198a307baabf%3A0xb5137c1bf18db1ea!2sKathmandu%2044600%2C%20Nepal!5e0!3m2!1sen!2sbd!4v1714324837639!5m2!1sen!2sbd"
                                width={600}
                                height={650}
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>
                    </div> */}
                    <Footer />
                </main>
                <style>
                    {`
                .bg-custom {
                    background-color:white !important;
                    border-radius: 5px;
                    display: flex;
                    align-items: center;
                }
                `}
                </style>
            </div>
        </div>
    )
}

export default ContactPage